import { render, staticRenderFns } from "./AddOneKidsConfigDialog.vue?vue&type=template&id=f2e30bf2&scoped=true"
import script from "./AddOneKidsConfigDialog.vue?vue&type=script&lang=js"
export * from "./AddOneKidsConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOneKidsConfigDialog.vue?vue&type=style&index=0&id=f2e30bf2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e30bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2e30bf2')) {
      api.createRecord('f2e30bf2', component.options)
    } else {
      api.reload('f2e30bf2', component.options)
    }
    module.hot.accept("./AddOneKidsConfigDialog.vue?vue&type=template&id=f2e30bf2&scoped=true", function () {
      api.rerender('f2e30bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/AddOneKidsConfigDialog.vue"
export default component.exports